import { render } from "./upsell-products.vue?vue&type=template&id=6b286e8f"
import script from "./upsell-products.vue?vue&type=script&lang=js"
export * from "./upsell-products.vue?vue&type=script&lang=js"

import "./upsell-products.vue?vue&type=style&index=0&id=6b286e8f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__